import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FavoriteBorderIcon(props: IconProps) {
    return <Icon {...props} iconKey={"favorite_border"}/>
}
